import { render } from "./PcHeader.vue?vue&type=template&id=ad5391f8&scoped=true"
import script from "./PcHeader.vue?vue&type=script&lang=js"
export * from "./PcHeader.vue?vue&type=script&lang=js"

import "./PcHeader.vue?vue&type=style&index=0&id=ad5391f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5391f8"]])

export default __exports__